export const layoutStyles = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 360px',
  gap: '22px',
  alignItems: 'stretch',
  minHeight: '520px',
  '@media (max-width: 1000px)': {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
};

export const railStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  minWidth: 0,
};
